import * as IO from "../../helpers/io.js";
import { SchemaIO } from "../../helpers/schemaIO.js";
//
// Model.
//
export const RTagLinkName = "TagLink";
function tagLink(value) {
    return IO.literal(value, RTagLinkName);
}
const RAnyTagLink = (() => {
    const baseType = SchemaIO.string({
        minLength: 1,
        maxLength: 100,
    });
    return new IO.RefinementType(RTagLinkName, baseType.is, baseType.validate, baseType.encode, baseType, () => true);
})();
//
// Exports.
//
export const TagLink = {
    io: tagLink,
};
export const AnyTagLink = {
    io: () => RAnyTagLink,
};
